import { 
        InfoContainer7, 
        InfoWrapper, 
        InfoRow, 
        Column1, 
        Column2,
        TextWrapper, 
        TopLine, 
        Heading, 
        Subtitle, 
        Subtitle2, 
        Subtitle3, 
        ImgWrap, 
        Img 
} from './InfoElements7'

const InfoSection7 = ({ imgStart, topLine, headline, description, description2, description3, img, alt }) => {
  return (
    <>
       <InfoContainer7>
            <InfoWrapper id='about'>
                <InfoRow imgStart={imgStart}>
                    <Column1>
                        <TextWrapper>
                            <TopLine>{topLine}</TopLine>
                            <Heading>{headline}</Heading>
                            <Subtitle>{description}</Subtitle>
                            <Subtitle2>{description2}</Subtitle2>
                            <Subtitle3>{description3}</Subtitle3>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <Img src={img} alt={alt} />
                        </ImgWrap>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer7> 
    </>
  )
}

export default InfoSection7